import React, { useState } from 'react';
import axios from 'axios';

const ViolationReport = () => {
  const [formData, setFormData] = useState({
    violation_type: '',
    related_chart_id: '',
    related_chart_type: 'liuyao',
    violation_content: '',
    evidence_urls: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const violationTypes = [
    { value: 1, label: '未结算悬赏', description: '发布悬赏后未按时结算' },
    { value: 2, label: '发布违规内容', description: '包含违法、色情、暴力等内容' },
    { value: 3, label: '恶意回帖', description: '恶意灌水、刷屏、人身攻击' },
    { value: 4, label: '刷分刷声望', description: '通过不正当手段获取积分和声望' },
    { value: 5, label: '广告营销', description: '发布商业广告、营销信息' },
    { value: 6, label: '抄袭内容', description: '抄袭他人原创内容' },
    { value: 7, label: '骚扰用户', description: '私信骚扰、恶意举报等' },
    { value: 8, label: '泄露隐私', description: '泄露他人隐私信息' },
    { value: 9, label: '其他违规', description: '其他违反社区规范的行为' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.violation_type || !formData.violation_content) {
      setError('请填写违规类型和违规内容描述');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('access_token');
      const submitData = {
        ...formData,
        violation_type: parseInt(formData.violation_type),
        evidence_urls: formData.evidence_urls ? formData.evidence_urls.split('\n').filter(url => url.trim()) : null
      };

      await axios.post('/api/jifen/violation/report', submitData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSuccess(true);
      setFormData({
        violation_type: '',
        related_chart_id: '',
        related_chart_type: 'liuyao',
        violation_content: '',
        evidence_urls: ''
      });

    } catch (err) {
      setError('举报提交失败，请重试');
      console.error('举报失败:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  if (success) {
    return (
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-8">
        <div className="text-center">
          <div className="text-green-600 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">举报提交成功</h2>
          <p className="text-gray-600 mb-6">
            感谢您的举报，我们将尽快审核处理。处理结果将通过站内信通知您。
          </p>
          <button
            onClick={() => setSuccess(false)}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition duration-200"
          >
            继续举报
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">违规举报</h2>
        <p className="text-gray-600 mt-2">
          如果您发现违规行为，请及时举报。我们重视每一条举报，会认真核实并处理。
        </p>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-6">
          <p className="text-red-600">{error}</p>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* 违规类型 */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-3">
            违规类型 <span className="text-red-500">*</span>
          </label>
          <div className="space-y-3">
            {violationTypes.map((type) => (
              <label key={type.value} className="flex items-start">
                <input
                  type="radio"
                  name="violation_type"
                  value={type.value}
                  checked={formData.violation_type === type.value.toString()}
                  onChange={(e) => handleInputChange('violation_type', e.target.value)}
                  className="mt-1 text-blue-600 focus:ring-blue-500"
                />
                <div className="ml-3">
                  <div className="font-medium text-gray-900">{type.label}</div>
                  <div className="text-sm text-gray-600">{type.description}</div>
                </div>
              </label>
            ))}
          </div>
        </div>

        {/* 相关信息 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              图表类型
            </label>
            <select
              value={formData.related_chart_type}
              onChange={(e) => handleInputChange('related_chart_type', e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="liuyao">六爻</option>
              <option value="qimen">奇门</option>
              <option value="bazi">八字</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              相关图表ID（可选）
            </label>
            <input
              type="text"
              value={formData.related_chart_id}
              onChange={(e) => handleInputChange('related_chart_id', e.target.value)}
              placeholder="输入相关的图表ID"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        {/* 违规内容描述 */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            违规内容描述 <span className="text-red-500">*</span>
          </label>
          <textarea
            value={formData.violation_content}
            onChange={(e) => handleInputChange('violation_content', e.target.value)}
            placeholder="请详细描述违规行为，包括具体内容、发生时间、涉及用户等信息..."
            rows="6"
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <p className="text-sm text-gray-500 mt-1">
            详细的描述有助于我们更快地处理您的举报
          </p>
        </div>

        {/* 证据链接 */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            证据链接（可选）
          </label>
          <textarea
            value={formData.evidence_urls}
            onChange={(e) => handleInputChange('evidence_urls', e.target.value)}
            placeholder="每行一个链接，支持图片、截图等证据"
            rows="3"
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <p className="text-sm text-gray-500 mt-1">
            可以提供截图、链接等证据，支持多个链接（每行一个）
          </p>
        </div>

        {/* 举报须知 */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <h3 className="text-sm font-medium text-yellow-800 mb-2">举报须知</h3>
          <ul className="text-sm text-yellow-700 space-y-1">
            <li>• 请确保举报内容的真实性和准确性</li>
            <li>• 恶意举报可能导致账号被处罚</li>
            <li>• 我们会保护举报人的隐私</li>
            <li>• 处理结果将在3-5个工作日内反馈</li>
          </ul>
        </div>

        {/* 提交按钮 */}
        <div className="flex justify-end">
          <button
            type="submit"
            disabled={loading}
            className={`px-6 py-3 rounded-lg text-white font-medium transition duration-200 ${
              loading
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-red-500 hover:bg-red-600'
            }`}
          >
            {loading ? '提交中...' : '提交举报'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ViolationReport;